import React from 'react';
import { PageTitle, MainSectionPanel } from '../../components/common';

const SettingsPage: React.FC = () => {
  return (
    <MainSectionPanel>
      <PageTitle
        title="Settings"
        subtitle="Configuración del sistema"
      />
    </MainSectionPanel>
  );
};

export default SettingsPage;